import { render, staticRenderFns } from "./product_12_zsw.vue?vue&type=template&id=cea417b0&scoped=true"
import script from "./product_12_zsw.vue?vue&type=script&lang=js"
export * from "./product_12_zsw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea417b0",
  null
  
)

export default component.exports